import * as React from 'react';
import { IInvoiceFilter } from '../../../../Models/Invoice/IInvoiceFilter';
import {Checkbox, SpinButton, Stack, TextField} from '@fluentui/react';
import { isNumeric } from '../../../../Tools/Validation';

interface IInvoiceFilterViewProps {
    setFilter: (filter: IInvoiceFilter) => void;
    filter?: IInvoiceFilter;
    searchName?: boolean
}


export const InvoiceFilterView: React.FunctionComponent<IInvoiceFilterViewProps> = (props) => {

    const textChanged = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        if (event?.target) {
            var id = event.currentTarget.id;
             
                props.setFilter({ ...props.filter, [id]: newValue })
        }
    }

    const nezaplacene = (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {

        props.setFilter({ ...props.filter, ["onlyUnpaied"]: checked ? checked:false })
    }

    const poSplatnosti = (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {

        props.setFilter({ ...props.filter, ["onlyOverDue"]: checked ? checked : false })
    }

    const storno = (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {

        props.setFilter({ ...props.filter, ["onlyStorno"]: checked ? checked : false })
    }

    const yearChanged = (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, newValue?: string) => {

        props.setFilter({ ...props.filter, year: isNumeric(newValue) ? Number.parseInt(newValue) : undefined })
    }

    return (<Stack styles={{
        root: { paddingTop:15 }
    }} horizontal verticalAlign="end" tokens={{ childrenGap: 15 }}>

        <TextField label="Rok" key="yaer" id="yaer" styles={{ root: { width: 100 } }}
            value={props.filter?.year?.toString()}
            onChange={yearChanged}
            onGetErrorMessage={(value) => {
                return isNumeric(value)?"":"Hodnota musí být číslo"
            }}
        />
        <TextField label="Variabil. symbol" key="variabil" id="variabil" value={props.filter?.variabil} onChange={textChanged} />
        {props.searchName ? <TextField label="Zakaznik" key="userName" id="userName" value={props.filter?.userName} onChange={textChanged} /> : null}
        <Checkbox label="Pouze nezaplacené" onChange={nezaplacene} checked={props.filter?.onlyUnpaied} />
        <Checkbox label="Pouze po splatnosti" onChange={poSplatnosti} checked={props.filter?.onlyOverDue} />
        <Checkbox label="Pouze stornované" onChange={storno} checked={props.filter?.onlyStorno} />
    </Stack>)
}
